module.exports = __webpack_public_path__ + "static/media/therapy.8bf6333e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityBadge/icons/therapy.svg
// module id = 300
// module chunks = 0